module.exports = __webpack_public_path__ + "static/media/my-photo.82ff896c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-photo.png
// module id = 383
// module chunks = 0